declare const $: any; // jQuery global

function getCourseId(): string {
    return $("#course-delegates").data("courseId") ?? "";
}

function validateCourseForm(): void {
    let isValid = true;

    $("input[required], select[required]").each(function (this: any) {
        if (!$(this).val()) isValid = false;
    });

    $('input[id*="__Validated"]').each(function (this: any) {
        if ($(this).val()?.toString().toLowerCase() !== "true") isValid = false;
    });

    $("#course-checkout-btn button").prop("disabled", !isValid);
}

function associateValidationClicks(): void {
    // prevent stacking handlers
    $(".input-del-email")
        .off("blur")
        .on("blur", function (this: any) {
            const input = $(this);

            input.addClass("input-loading");
            input.removeClass("border-success border-2");

            const index = input.data("index");
            const email = input.val();

            if (!email) {
                input.removeClass("input-loading");
                validateCourseForm();
                return;
            }

            const validationElem = $(`.validated-member-txt[data-index=${index}]`);
            validationElem.hide();

            const encodedEmail = encodeURIComponent(email);
            const courseId = getCourseId();

            $.ajax({
                method: "GET",
                url: `/umbraco/surface/coursebookingsurface/validatemembership?email=${encodedEmail}&delIndex=${index}&courseId=${courseId}`,
                async: true
            }).done(function (result: any) {
                input.removeClass("input-loading");

                if (!result || !result.valid) {
                    validationElem.html(`<b>${email}</b> ${result?.reason || "could not be added."}`);
                    validationElem.removeClass("text-success").addClass("text-red").show();

                    input.removeClass("border-success border-2").addClass("input-validation-error");
                    $(`#Delegates_${index}__Validated`).val("false");
                } else {
                    validationElem.html(`<b>${email}</b> can attend this course.`);
                    validationElem.removeClass("text-red").addClass("text-success").show();

                    input.removeClass("input-validation-error").addClass("border-success border-2");
                    $(`#Delegates_${index}__Validated`).val("true");
                }

                validateCourseForm();
            });
        });

    $("input[required], select[required], .input-del-email")
        .off("change", validateCourseForm)
        .on("change", validateCourseForm);
}

export function initCourseBookingPage(): void {
    $(document).on("change", "select.course-quantity", function (this: any) {
        const $this = $(this);
        const form = $this.parents("form");
        const quantity = parseInt(this.value, 10);

        updateDelegates(form, quantity);
        associateValidationClicks();
        validateCourseForm();
    });

    // initial setup - handle server re-render with session data
    const $quantitySelect = $("select.course-quantity");
    const initialQuantity = parseInt($quantitySelect.val(), 10) || 0;
    if (initialQuantity > 0) {
        updateDelegates($quantitySelect.parents("form"), initialQuantity);
    }
    associateValidationClicks();
    validateCourseForm();

    // Restore visual validation state for delegates pre-filled from session
    $(".input-del-email").each(function(this: any) {
        const input = $(this);
        const index = input.data("index");
        const email = input.val();
        if (email && $(`#Delegates_${index}__Validated`).val()?.toString().toLowerCase() === "true") {
            input.addClass("border-success border-2");
            const msg = $(`.validated-member-txt[data-index=${index}]`);
            msg.html(`<b>${email}</b> can attend this course.`);
            msg.removeClass("text-red").addClass("text-success").show();
        }
    });
}

function updateDelegates(form: any, quantity: number): void {
    const delegates = form.find("#course-delegates");
    const checkoutBtn = form.find("#course-checkout-btn");

    if (quantity === 0) {
        checkoutBtn.hide();
        delegates.html("");
        return;
    }

    let wrapper = delegates.find(".delegate-information");
    if (!wrapper.length) {
        delegates.html(`<div class="delegate-information forms text"><h2 class="mb-4">Delegate Information</h2></div>`);
        wrapper = delegates.find(".delegate-information");
    }

    const rows = wrapper.children(".delegate-form");
    const currentCount = rows.length;

    if (currentCount > quantity) {
        for (let i = currentCount - 1; i >= quantity; i--) {
            rows.eq(i).remove();
        }
    } else if (currentCount < quantity) {
        const template = $("template#course-delegate-template")[0] as HTMLTemplateElement | undefined;
        if (!template) {
            console.warn("No <template id='course-delegate-template'> found for delegate rows.");
        } else {
            for (let i = currentCount; i < quantity; i++) {
                const html = template.innerHTML
                    .replace(/\{\{index\}\}/g, i.toString())
                    .replace(/\{\{delegate_title\}\}/g, `Delegate ${i + 1}`);
                wrapper.append(html);
            }
        }
    }

    checkoutBtn.show();
}
